var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_5825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.74002 12.0579L2.80002 9.11787C2.39999 8.7173 2.39999 8.06843 2.80002 7.66787L5.87002 4.59787C6.27058 4.19785 6.91945 4.19785 7.32002 4.59787L9.26002 6.53787",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2602 15.5381L20.2002 17.4781C20.6003 17.8787 20.6003 18.5275 20.2002 18.9281L17.1302 21.9981C16.7297 22.3981 16.0808 22.3981 15.6802 21.9981L12.7402 19.0581",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7663 9.90039L4.14848 17.5182C3.588 18.0774 3.36871 18.8933 3.57333 19.6581C3.77795 20.4229 4.37534 21.0203 5.14017 21.2249C5.905 21.4296 6.72088 21.2103 7.28007 20.6498L14.8979 13.032",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7659 9.90019C11.3329 8.63172 11.4298 7.24224 12.0345 6.04609C12.6393 4.84995 13.7008 3.94821 14.9791 3.5449C15.6202 3.33177 16.2989 3.25583 16.9713 3.322C17.3489 3.37244 17.6649 3.63354 17.7856 3.99494C17.9063 4.35634 17.8107 4.75492 17.5391 5.0222L15.7349 6.82634C15.6411 6.92009 15.5884 7.04727 15.5884 7.17989C15.5884 7.3125 15.6411 7.43968 15.7349 7.53343L17.2642 9.06279C17.4595 9.25804 17.7761 9.25804 17.9714 9.06279L19.7755 7.25865C20.0427 6.98709 20.4413 6.89144 20.8027 7.01213C21.1641 7.13283 21.4252 7.4488 21.4756 7.82646C21.5419 8.49881 21.4659 9.17757 21.2527 9.81865C20.8495 11.0969 19.9478 12.1585 18.7516 12.7632C17.5555 13.368 16.166 13.4648 14.8976 13.0318",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_5825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.95fe2084acc354b903dbcc39dcb3bc2d.svg";
export { ForwardRef as ReactComponent };